import type { ReactNode } from 'react';
import { Card } from 'react-bootstrap';
import { SampleAccentHeading } from './SampleAccentHeading';

export type SamplePanelCardHeaderProps = {
  /** Font Awesome クラス（例: fa-flask）。省略可 */
  icon?: string;
  title: ReactNode;
  trailing?: ReactNode;
  className?: string;
};

/** サンプル管理系パネルの密アクセント見出し */
export function SamplePanelCardHeader({
  icon,
  title,
  trailing,
  className,
}: SamplePanelCardHeaderProps) {
  return (
    <Card.Header className={`p-0 border-0 bg-transparent${className ? ` ${className}` : ''}`.trim()}>
      <SampleAccentHeading
        icon={icon}
        trailing={trailing}
        className="sample-panel-card-header"
      >
        {title}
      </SampleAccentHeading>
    </Card.Header>
  );
}
